module.exports = __webpack_public_path__ + "static/media/sass-1.b446ca5a.svg";